import styled, { css } from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { FlexColumn } from 'src/components/Reusable/Flex'

export const ChatSearchModalContent = styled(FlexColumn)`
  width: 100%;
  height: 500px; /* Fixed height instead of max-height */
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  align-items: stretch;
`

export const ChatSearchHeader = styled.div`
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  color: ${palette.neutral[900]};
  border-bottom: 1px solid ${palette.neutral[100]};
`

export const ChatSearchInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-bottom: 1px solid ${palette.neutral[100]};
  font-size: 14px;
  outline: none;
  color: ${palette.neutral[900]};
  box-sizing: border-box;
  margin-bottom: 8px;

  &::placeholder {
    color: ${palette.neutral[400]};
  }

  &:focus {
    outline: none;
    border-bottom-color: ${palette.neutral[200]};
  }
`

export const ChatSearchResultsContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  width: 100%;
  min-height: 0; /* Allow flex child to shrink */

  /* Prevent scroll from propagating to parent */
  overscroll-behavior: contain;
`

export const ChatSearchResultItem = styled.a`
  padding: 8px 0;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-decoration: none;
  color: inherit;
  width: 100%;
  border-radius: 4px;

  &:hover {
    background-color: ${palette.neutral[50]};
    text-decoration: none;
    color: inherit;
  }
`

export const ChatSearchResultTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${palette.neutral[700]};
  line-height: 1.4;
  margin-bottom: 2px;
`

export const ChatSearchResultSnippet = styled.div`
  font-size: 12px;
  color: ${palette.neutral[600]};
  line-height: 1.4;
  margin-top: 2px;

  :global(mark) {
    background-color: ${palette.orange[200]};
    padding: 2px 0;
  }
`

export const ChatSearchEmptyState = styled.div`
  padding: 40px 16px;
  text-align: center;
  font-size: 14px;
  color: ${palette.neutral[500]};
`

export const ChatSearchLoaderContainer = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
`

export const ChatSearchLoaderItem = styled.div`
  display: block;

  svg {
    display: block;
  }
`

export const ChatSearchNewChatRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin: 0 12px 8px 12px;
  background-color: ${palette.neutral[50]};
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
  color: ${palette.neutral[900]};
  font-size: 14px;
  font-weight: 500;

  &:hover {
    background-color: ${palette.neutral[100]};
    text-decoration: none;
    color: ${palette.neutral[900]};
  }
`

export const ChatSearchDateGroup = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  gap: 0;
  margin-top: 8px;

  &:first-child {
    margin-top: 0;
  }
`

export const ChatSearchDateLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${palette.neutral[500]};
  padding: 8px 0 4px 0;
`

export const ChatSearchChatList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0;
  padding-left: 0;
`

export const ChatSearchChatItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  width: 100%;
`

export const ChatSearchChatIcon = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: ${palette.neutral[500]};
`

// Global styles for chat search modal
export const ChatSearchModalGlobalStyles = css`
  /* Target modal-content when it contains our chat search input - override styled-components */
  .modal-content:has(input[placeholder='Search chats...']) {
    padding-top: 0 !important;
  }

  /* Target close button when modal contains our chat search input - it's absolutely positioned */
  .modal-content:has(input[placeholder='Search chats...'])
    button[data-testid='close-modal'] {
    top: 20px !important; /* 8px (small space) + 12px (original top) = 20px */
  }

  /* Remove outline on SVG focus */
  svg:focus {
    outline: none;
  }

  svg:focus-visible {
    outline: none;
  }
`
